/* eslint-disable import/prefer-default-export */
import DashAceEditor from './components/DashAceEditor.react';

export {
    DashAceEditor
};
